const wbbHomepageEditorConfig = {
  initialContent: {
    hero_eyebrow: "",
    hero_title: "",
    hero_subtitle: "",
    hero_button_label: "REGISTER NOW",
    hero_button_link: "",

    tournament_section_title: "Tournament Details",
    tournament_section_subtitle: "",
    tournament_date: "",
    tournament_price: "",
    tournament_format: "",
    tournament_games: "",
    tournament_location: "",

    logo_image_url: "",
    hero_image_url: "",
  },

  imageFields: {
    logo: {
      contentKey: "logo_image_url",
    },

    hero: {
      contentKey: "hero_image_url",
    },
  },

  loadContent(content = {}) {
    return {
      ...this.initialContent,
      ...content,
    };
  },

  buildContent(templateState = {}, sharedState = {}) {
    return {
      hero_eyebrow:
        templateState.hero_eyebrow?.trim() || "",

      hero_title:
        templateState.hero_title?.trim() || "",

      hero_subtitle:
        templateState.hero_subtitle?.trim() || "",

      hero_button_label:
        templateState.hero_button_label?.trim() || "REGISTER NOW",

      hero_button_link:
        templateState.hero_button_link?.trim() || "",

      tournament_section_title:
        templateState.tournament_section_title?.trim() ||
        "Tournament Details",

      tournament_section_subtitle:
        templateState.tournament_section_subtitle?.trim() || "",

      tournament_date:
        templateState.tournament_date?.trim() || "",

      tournament_price:
        templateState.tournament_price?.trim() || "",

      tournament_format:
        templateState.tournament_format?.trim() || "",

      tournament_games:
        templateState.tournament_games?.trim() || "",

      tournament_location:
        templateState.tournament_location?.trim() || "",

      logo_image_url:
        sharedState.resolvedImageUrls?.logo || "",

      hero_image_url:
        sharedState.resolvedImageUrls?.hero || "",
    };
  },

  getStep2Props({
    templateState,
    setTemplateField,
    getImageField,
    setImageFile,
    setImageRemoved,
  }) {
    const logo = getImageField("logo");
    const hero = getImageField("hero");

    return {
      templateState,
      setTemplateField,

      logoImageFile: logo.file,

      setLogoImageFile: (file) =>
        setImageFile("logo", file),

      existingLogoImageUrl:
        logo.existingUrl,

      removeLogoImage:
        logo.remove,

      setRemoveLogoImage: (remove) =>
        setImageRemoved("logo", remove),

      heroImageFile: hero.file,

      setHeroImageFile: (file) =>
        setImageFile("hero", file),

      existingHeroImageUrl:
        hero.existingUrl,

      removeHeroImage:
        hero.remove,

      setRemoveHeroImage: (remove) =>
        setImageRemoved("hero", remove),
    };
  },
};

export default wbbHomepageEditorConfig;